import FormArea from './FormArea';
export default FormArea;
